import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PayIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PayIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M17.8223 21.2925H5.59131C3.61084 21.2925 2 19.6816 2 17.7017V6.29834C2 4.31836 3.61084 2.70752 5.59131 2.70752H16.4072C17.8193 2.70752 18.9683 3.85596 18.9683 5.26807V6.03711C18.9683 6.31348 18.7446 6.53711 18.4683 6.53711C18.1919 6.53711 17.9683 6.31348 17.9683 6.03711V5.26807C17.9683 4.40772 17.2681 3.70752 16.4072 3.70752H5.59131C4.1626 3.70752 3 4.86963 3 6.29834V17.7017C3 19.1304 4.1626 20.2925 5.59131 20.2925H17.8223C18.6826 20.2925 19.3828 19.5923 19.3828 18.7319V16.5478C19.3828 16.2715 19.6065 16.0478 19.8828 16.0478C20.1592 16.0478 20.3828 16.2715 20.3828 16.5478V18.7319C20.3828 20.144 19.2344 21.2925 17.8223 21.2925Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.8828 9.56934C19.6064 9.56934 19.3828 9.34571 19.3828 9.06934V8.3003C19.3828 7.43946 18.6826 6.73926 17.8223 6.73926H5.93604C5.65967 6.73926 5.43604 6.51563 5.43604 6.23926C5.43604 5.96289 5.65967 5.73926 5.93604 5.73926H17.8223C19.2344 5.73926 20.3828 6.88819 20.3828 8.3003V9.06934C20.3828 9.34571 20.1592 9.56934 19.8828 9.56934Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.5 16.6436H15.773C14.2715 16.6436 13.0498 15.4219 13.0498 13.9204C13.0498 12.4185 14.2715 11.1968 15.773 11.1968H21.5C21.7764 11.1968 22 11.4204 22 11.6968V16.1436C22 16.4199 21.7764 16.6436 21.5 16.6436ZM15.773 12.1968C14.8228 12.1968 14.0498 12.9702 14.0498 13.9204C14.0498 14.8706 14.8228 15.6435 15.773 15.6435H21V12.1968L15.773 12.1968Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PayIcon;
